import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, CalendarIcon2 } from '../components/shared/Icons';
import FilterPeriodical from './FilterPeriodical';
import FilterSouthYarra from './FilterSouthYarra';
import CalendarIframe from './CalendarIframe';
import FilterTickets from './FilterTickets';






const TABS = [
  {
    id: 'update',
    label: 'Updates',
    
  },
  {
    id: 'calendar',
    label: 'Calendar',
    
  },
  
];




const UPDATE_INNER = [
  { id: 'periodicalupdate', label: 'Periodical', icon: <EditIcon />, component: FilterPeriodical },
  { id: 'southyarraupdate', label: 'South Yarra', icon: <EditIcon />, component: FilterSouthYarra },
  { id: 'ticketupdate', label: 'Ticket', icon: <EditIcon />, component: FilterTickets },
];



const CALENDAR_INNER = [
  { id: 'periodicalcalendar', label: 'Periodical', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appciHwOR34Suu6Qm/shrBE23qCf1H3HSdI?backgroundColor=dark" /> },
  { id: 'southyarracalendar', label: 'South Yarra', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/apprjJS4aecux6Cf1/shrv09STVpiDCFpQY?backgroundColor=dark" /> },
  { id: 'ticketcalendar', label: 'Ticket', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shrwa9EFvZh0NgL20?backgroundColor=dark" /> },
];










const FiltersStaffPage = () => {
  const [activeTab, setActiveTab] = useState('update');
  const { homeAccent } = useUser();

 


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'update' && <InnerTabsd tabs={UPDATE_INNER} defaultId="periodicalupdate"/>}
        {activeTab === 'calendar' && <InnerTabsd tabs={CALENDAR_INNER} />}
        
      </div>
    </div>
  );
};



export default FiltersStaffPage;